import React from 'react';
import {Link} from 'react-router';
import cx from 'classnames';

import styles from './Product.m.sass';

import arrowRightIcon from '../../components/button/assets/arrow-right.svg';
import Button from '../button/Button';
import Badge from '../badge/Badge';
import ChannelImage from '../../containers/channelUtils/ChannelImage';
import ChannelPrice from '../../containers/channelUtils/ChannelPrice';

export default class Product extends React.PureComponent {
  render() {
    const {wide, related, horizontal} = this.props;
    const {slug, name, label, image, price} = this.props;

    return (
      <Link
        to={`/service/${slug}`}
        className={cx(
          styles.product,
          {[styles.productWide]: wide},
          {[styles.productRelated]: related},
          {[styles.productHorizontal]: horizontal},
        )}
      >
        <div className={styles.productWrapper}>
          <div className={styles.productGradient}>
            <div className={styles.productBorder}>
              <div className={styles.productInner}>
                <div className={styles.productImage}>
                  <ChannelImage
                    src={image}
                    alt={name}
                  />
                </div>

                {label && (
                  <div className={styles.productBadges}>
                    <Badge>{label}</Badge>
                  </div>
                )}

                <div className={styles.productHeader}>
                  {name}
                </div>

                <p className={styles.productPrice}>
                  <ChannelPrice price={price}/>
                </p>

                <div className={styles.productAction}>
                  <Button icon={arrowRightIcon} iconPosition="right" small>Buy now</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Link>
    );
  }
}



// WEBPACK FOOTER //
// ./components/product/Product.js